<template>
  <v-dialog v-model="opened" max-width="720" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card class="delivery-dialog-card" :dark="$theme.dark" :class="{ 'delivery-dialog-card-dark': $theme.dark }">
      <v-card-title class="delivery-dialog-title">
        <div>
          <strong>{{ clientName(delivery) }}</strong>
          <small>Venda #{{ saleNumber(delivery) }}</small>
        </div>
        <v-spacer />
        <v-btn icon @click="opened = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="delivery-dialog-grid">
          <div>
            <span>Endereço</span>
            <strong>{{ addressLabel(delivery.address_destiny) }}</strong>
          </div>
          <div>
            <span>Data</span>
            <strong>{{ delivery.visit_date }} {{ delivery.visit_hour }}</strong>
          </div>
          <div>
            <span>Responsável</span>
            <strong>{{ userName(delivery.executor) }}</strong>
          </div>
          <div>
            <span>Veículo</span>
            <strong>{{ vehicleLabel(delivery.vehicle) }}</strong>
          </div>
        </div>
        <v-divider class="my-4" />
        <v-textarea
          dense
          filled
          :dark="$theme.dark"
          label="Comentário"
          rows="3"
          v-model="comment"
        />
        <div class="delivery-comments">
          <div v-for="(item, index) in delivery.comments || []" :key="index">
            <strong>{{ userName(item.executor) }}</strong>
            <p>{{ item.description }}</p>
            <a v-if="item.attachment && item.attachment.link" :href="item.attachment.link" target="_blank">
              <img v-if="item.attachment.type === 'photo'" :src="item.attachment.link" alt="Foto da entrega" />
              <span v-else>{{ item.attachment.name || "Anexo" }}</span>
            </a>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn text :dark="$theme.dark" :to="saleLink(delivery)">Abrir venda</v-btn>
        <v-spacer />
        <v-btn text :dark="$theme.dark" @click="saveComment" :disabled="!comment">Comentar</v-btn>
        <v-btn color="green" dark @click="emitStatus('on_the_way')">Iniciar rota</v-btn>
        <v-btn color="blue" dark @click="emitStatus('done')">Concluir</v-btn>
        <v-btn color="red" dark @click="emitStatus('canceled')">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      opened: false,
      delivery: {},
      comment: ""
    };
  },
  methods: {
    open(delivery) {
      this.delivery = delivery || {};
      this.comment = "";
      this.opened = true;
    },
    saveComment() {
      this.$emit("comment", this.delivery, this.comment);
      this.comment = "";
    },
    emitStatus(status) {
      this.$emit("status", this.delivery, status);
      this.opened = false;
    },
    clientName(delivery) {
      return delivery.client && delivery.client.nome ||
        delivery.sale_summary && delivery.sale_summary.client && delivery.sale_summary.client.nome ||
        "Cliente não informado";
    },
    saleNumber(delivery) {
      return delivery.sale_summary && delivery.sale_summary.id_transacao || delivery.transaction || "-";
    },
    saleLink(delivery) {
      return `/gestordepedidos/venda/${delivery.transaction}`;
    },
    userName(user) {
      return user && user.nome || "Não informado";
    },
    vehicleLabel(vehicle) {
      if (!vehicle) return "Sem veículo";
      return [vehicle.placa, vehicle.modelo].filter(Boolean).join(" - ") || "Sem veículo";
    },
    addressLabel(address = {}) {
      return [
        address.street,
        address.number ? `nº ${address.number}` : "",
        address.bairro,
        address.city || address.cidade,
      ].filter(Boolean).join(", ") || "Endereço não informado";
    }
  }
};
</script>

<style scoped>
.delivery-dialog-card-dark {
  background: #101f24 !important;
  color: #edf5f2;
}
.delivery-dialog-title {
  align-items: center;
  display: flex;
}
.delivery-dialog-title strong,
.delivery-dialog-title small {
  display: block;
}
.delivery-dialog-title small,
.delivery-dialog-grid span {
  color: #6a756f;
  font-size: 12px;
}
.delivery-dialog-card-dark .delivery-dialog-title small,
.delivery-dialog-card-dark .delivery-dialog-grid span {
  color: #b7c8c2;
}
.delivery-dialog-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.delivery-dialog-grid div {
  background: #f5f7f4;
  border: 1px solid #dde6df;
  border-radius: 8px;
  padding: 12px;
}
.delivery-dialog-card-dark .delivery-dialog-grid div {
  background: #0b1518;
  border-color: #244149;
}
.delivery-dialog-grid strong {
  color: #21342b;
  display: block;
  font-size: 13px;
}
.delivery-dialog-card-dark .delivery-dialog-grid strong {
  color: #f2fbf7;
}
.delivery-comments {
  display: grid;
  gap: 8px;
}
.delivery-comments div {
  border-left: 3px solid #1f8f55;
  padding-left: 10px;
}
.delivery-comments p {
  margin: 0;
}
.delivery-comments a {
  color: #1f8f55;
  display: inline-block;
  font-size: 12px;
  margin-top: 6px;
}
.delivery-comments img {
  border-radius: 8px;
  display: block;
  max-height: 130px;
  object-fit: cover;
  width: 180px;
}
@media(max-width: 720px) {
  .delivery-dialog-title {
    padding-right: 8px;
  }
  .delivery-dialog-grid {
    grid-template-columns: 1fr;
  }
  .v-card__actions {
    align-items: stretch;
    display: grid;
    gap: 8px;
    grid-template-columns: 1fr;
    padding: 12px 16px 18px;
  }
  .v-card__actions .v-btn {
    margin: 0;
    min-height: 40px;
  }
  .v-card__actions .spacer {
    display: none;
  }
}
</style>
